import { useQuery, UseQueryResult } from 'react-query';
import apiFetch, { defaultApiFetchErrorHandler, HTTPError } from 'react-scale/lib/api-fetch';
import { GetReferralRewardsConfigResponse } from '@scale/shared-types';

export const useFetchReferralRewardsConfig = (
  onSuccess?: (res: GetReferralRewardsConfigResponse) => void,
): UseQueryResult<GetReferralRewardsConfigResponse, unknown> => {
  return useQuery(
    ['useFetchReferralRewardsConfig'],
    async () => {
      const response = await apiFetch<GetReferralRewardsConfigResponse>(
        null,
        '/internal/referrals/referral-rewards-config',
        {
          method: 'GET',
        },
      );
      return response;
    },
    {
      onSuccess,
      onError: (err: HTTPError) => defaultApiFetchErrorHandler(err, { handleHttp: true }),
    },
  );
};
